import React from 'react';
import { motion } from 'framer-motion';
export function PreviewSection() {
  return <section className="py-8 bg-white" data-id="element-75">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-76">
        <motion.h2 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-serif text-coffee-dark mb-6" data-id="element-77">
          ¿Qué vas a encontrar dentro?
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="max-w-md mx-auto" data-id="element-78">
          <div className="aspect-[3/4] bg-coffee-light/10 border-2 border-dashed border-coffee-light/30 rounded-lg flex items-center justify-center" data-id="element-79">
            <p className="text-coffee/40 font-light text-sm" data-id="element-80">
              Preview del libro
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}